import { apiClient, makeServicePlugin, BaseModel } from '@/api'

class Subscription extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Subscription'
  // Define default properties here
  static instanceDefaults() {
    return {
      account_id: null,
      paypal_plan: null,
      paypal_subscription: null,
      start_date: null,
      end_date: null,
      suspend_date: null,
      cancel_date: null,
      price: 0,
      active: false,
      needs_revision: false,
      locked: false,
      free: false,
      includes_trial: true
    }
  }
}

const servicePath = 'subscription'
const servicePlugin = makeServicePlugin({
  Model: Subscription,
  service: apiClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
apiClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin